import { FC } from "react";
import styled from "styled-components";
import { CameraPreview } from "./CameraPreview";
import Room from "./Room";
import { ChatContextProvider } from "../context/ChatContext";
import { useRoom } from "../hooks/useRoom";
import useQuery from "../utils/useQuery";
import ExposeHooks from "../components/ExposeHooks";

const Container = styled("div")`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
`;

const VideoChat: FC = () => {
  const { connected, room } = useRoom();
  const telemedicineToken = useQuery().get("token");

  return (
    <Container>
      {connected && room ? (
        <ChatContextProvider>
          <Room room={room} token={telemedicineToken || ""} />
        </ChatContextProvider>
      ) : (
        <CameraPreview />
      )}
      {process.env.NODE_ENV === "development" && <ExposeHooks />}
    </Container>
  );
};

export default VideoChat;
